export default "__VITE_ASSET__HWgqG3J7__"